import { getVideoMenuTabLinks } from './videoMenuTabLinks';
import { getProjectTabLinks } from './projectsTabLinks';
import { LinkTabProps, Tab, TabPages } from './types';
import { getOrganizationTabLinks } from './organizationTabLinks';
import { getProfileTabLinks } from './profileTabLinks';
import { getUsersTabLinks } from './usersTabLinks';

export class TabLinkService {
  static get(page: TabPages, tabLinkArgs: LinkTabProps): Tab[] {
    switch (page) {
      case 'video-menus':
        return getVideoMenuTabLinks(tabLinkArgs);
      case 'projects':
        return getProjectTabLinks(tabLinkArgs);
      case 'profile':
        return getProfileTabLinks();
      case 'users':
        return getUsersTabLinks(tabLinkArgs);
      case 'organizations':
        return getOrganizationTabLinks(tabLinkArgs);
      default: return [];
    }
  }
}
